import React from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, Button, Card, Row, Col, Tag } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { s } from './style'
import numeral from 'numeral'
import { NUMERAL_FORMAT, ROUTES } from '../../../Constants'
import { useHistory } from 'react-router-dom'
import TransportIcon from '../TransportIcon'
import { formatCents, createCompressedImgxImageUrl } from '../../../Utilities'
import { AllPropsProposalCardProposalFragment } from './ProposalCard.generated-types'

const IMAGE_HEIGHT: number = 210

const { Text } = Typography
interface CompProps {
  proposal: AllPropsProposalCardProposalFragment
}

export const ProposalCard: React.FC<CompProps> = ({
  proposal: {
    UUID,
    baseCostTotal,
    space: {
      spaceName,
      venue,
      venue: { nearestTransit },
      spacePhotos,
    },
    attendees,
    currency,
    status,
  },
}) => {
  const history = useHistory()

  const { t } = useTranslation()

  const isRequestedToBooked = status === 'RequestedToBook'

  return (
    <Card
      hoverable
      style={s.proposalCard}
      cover={
        <section style={{ position: 'relative' }}>
          {spacePhotos.length && spacePhotos[0].url ? (
            <img
              alt={`${spaceName}, ${venue.name}`}
              src={createCompressedImgxImageUrl({
                originalImgxImageUrl: spacePhotos[0].url,
                height: IMAGE_HEIGHT,
              })}
              style={{
                height: IMAGE_HEIGHT,
                width: '100%',
                objectFit: 'cover',
              }}
            />
          ) : null}
          {isRequestedToBooked && (
            <Tag color="blue" style={{ position: 'absolute', top: 8, left: 8 }}>
              {t('label.requestedToBook', 'Requested to book')}
            </Tag>
          )}
        </section>
      }
    >
      <Row
        justify="space-between"
        gutter={[0, 24]}
        style={{ marginBottom: '36px' }}
      >
        <Col>
          <Text style={s.spaceName}>{spaceName}</Text>
          <br />
          <Text style={s.venueName}>{venue?.name}</Text>
        </Col>
        <Col>
          <Text style={s.labelText}>
            {formatCents(currency, baseCostTotal)}
          </Text>
        </Col>
      </Row>
      <Row
        justify="space-between"
        gutter={[0, 24]}
        style={{ marginBottom: '32px' }}
      >
        {nearestTransit && (
          <Col>
            <Text style={s.labelText}>
              <TransportIcon width={16} height={16} />
              {` ${nearestTransit.station}`}
            </Text>
            <br />
            <Text
              style={{
                fontSize: '14px',
                fontWeight: 400,
                color: '#262626',
              }}
            >
              {`${numeral(nearestTransit.distanceKm).format('0.0')} km`}
            </Text>
          </Col>
        )}
        <Col>
          <UserOutlined />
          {` ${numeral(attendees).format(NUMERAL_FORMAT)}`}
        </Col>
      </Row>
      <Button
        block
        type="primary"
        href={history.createHref({
          pathname: `${ROUTES.PROPOSAL}/${UUID}`,
        })}
        target="_blank"
        rel="noopener noreferrer"
      >
        {isRequestedToBooked ? 'View chosen proposal' : 'View proposal'}
      </Button>
    </Card>
  )
}
